import { styled } from "styled-components";

export const StyledContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  background: #f7f7f7;
`;

export const StyledContent = styled.div`
  display: flex;
  width: calc(100% - 2rem);
  max-width: 1380px;
  margin: 0 auto;
  background: #f7f7f7;
`;

export const StyledChildren = styled.div`
  display: flex;
  width: 100%;
  background: #f7f7f7;
  padding-bottom: 50px;
`;
export const StyledForm = styled.div``;
